import WorkflowStepPermittee from "./workflowStepPermittee";
import IRepo from "../../../../../common/interfaces/repo";
import Repo from "../../../../../common/state/modules/repo";

export default class Mover extends WorkflowStepPermittee  {
  static repo: IRepo<Mover> = new Repo<Mover>('movers', Mover);

  get rootName(): string {
    return 'movers';
  }
}

